var Environment = (function () {
    function Environment() {
    }
    Environment.serialize = function () {
        return {
            transport: this.transport(),
            origin: this.origin()
        };
    };
    Environment.origin = function () {
        return (window.location.origin ||
            window.location.protocol + "//" + window.location.hostname);
    };
    Environment.transport = function () {
        if (window.XDomainRequest) {
            return "XDomainRequest";
        }
        else if (window.XMLHttpRequest && !window.fetch) {
            return "XMLHttpRequest";
        }
        else {
            return "fetch";
        }
    };
    Environment.supportsPromises = function () {
        var P = window.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            }
            catch (e) {
            }
            if (promiseToString === "[object Promise]" && !P.cast) {
                return true;
            }
            if (promiseToString === "[object Object]" &&
                Promise.prototype._guidKey) {
                return true;
            }
        }
        return false;
    };
    return Environment;
}());
export { Environment };
//# sourceMappingURL=environment.js.map